export const LS_KEY = 'mgWeb'
export const LS_JWT_TOKEN = `${LS_KEY}JwtToken`
